import "./BidDetails.scss";
import { useParams } from "react-router-dom";
import { TenderCardAction } from "../TenderCardAction/TenderCardAction";
import { Icon } from "@mdi/react";
import { mdiFileDocumentOutline, mdiInformationOutline } from "@mdi/js";
import { isBidder, isNoticeCategoryEOI } from "../../utils/services";
import { useAuth } from "../Context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { catchError } from "../utils/catchError";
import { saveTenderBid, tenderBid } from "../Api/PostApi";
import { AdditionalAttributes } from "../FormikWrapper/TenderFormikWrapper";
import { ModalContext } from "../Context/ModalContext/ModalContext";
import { useContext } from "react";
import { Note } from "../Info";
import { ITenderAttributes } from "../utils/interface";

export interface DetailBid {
  tender_number: number;
  pubilshing_date: string;
  submission_date: any;
  notice_category: string;
  project_category: Array<ITenderAttributes>;
  procurement_type: Array<ITenderAttributes>;
  title: string;
  district: string;
  public_entity_name: string;
  ppmoFileUrl?: string;
  isPrivate?: boolean;
  publisherId: number;
  image?: string;
  boq?: any;
  savebids?: boolean;
  notes?: string;
  terms?: string;
  show_boq_item_rate?: boolean;
  category: string;
  opening_date: string;
  specification_terms_format: string;
  technical_pass: boolean | null;
  isVat: boolean;
  privateBid?: boolean;
  remainingDays?: number;
  hide_bidder: boolean;
  open_bid?: boolean;
  additional_attributes: AdditionalAttributes[];
  systemBidFee?: boolean;
  isMain: boolean;
}

interface BidProps {
  bidDetail: DetailBid | undefined;
  detailView: boolean | false;
}

export const BidDetails: React.FC<BidProps> = ({ bidDetail, detailView }) => {
  const { id } = useParams();
  const { role, isAuthenticate, eligible } = useAuth();
  const shareUrl = detailView ? `bids/view/${id}` : `tender-bid/${id}`;
  const { TogglePopUpFlags } = useContext(ModalContext);

  const handleButtonClick = () => {
    window.open(bidDetail?.specification_terms_format, "_blank");
  };

  const addBidToMyBids = (tender_id: string | number | undefined) => {
    const data = {
      tender_notice_id: tender_id,
    };
    tenderBid(data)
      .then((res) => {
        if (res.status === 202) {
          toast.error(res.data.status.status_message);
        }
        if (res.status === 200) {
          toast.success("Successfully added the bid ");
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          return TogglePopUpFlags("login");
        }
        catchError(
          err.response.status,
          err.response.data.status.status_message
        );
      });
  };

  const saveBids = (tender_id: string | number | undefined) => {
    saveTenderBid(tender_id)
      .then((res) => {
        toast.success("Bid Saved Successfully");
      })
      .catch((err) => {
        catchError(
          err.response.status,
          err.response.data.status.status_message
        );
      });
  };

  const handleOnClickBid = (id: number) => {
    if (isAuthenticate && isBidder(role)) {
      if (eligible) {
        addBidToMyBids(id);
      } else {
        TogglePopUpFlags("editCompanyDetail");
      }
    } else {
      TogglePopUpFlags("login");
    }
  };

  return (
    <>
      <div className="card details-section ">
        <div className="padd-16">
          <div className="card-wrapper">
            <p className="bid-details mg-bottom-24">Bid Details</p>

            <TenderCardAction
              shareUrl={shareUrl}
              boq={bidDetail?.boq}
              tender_id={Number(id)}
              savebids={bidDetail?.savebids}
              title={bidDetail?.title}
              image={bidDetail?.image}
              ppmoFileUrl={bidDetail?.ppmoFileUrl}
              notes={bidDetail?.notes}
              terms={bidDetail?.terms}
              show_boq_item_rate={bidDetail?.show_boq_item_rate}
              privateBid={bidDetail?.privateBid}
              additional_attributes={bidDetail?.additional_attributes}
            />
            <div className="d-flex align-center">
              {/* <ShareButton size={iconSize} shareUrl={shareUrl} /> */}

              <div className="border-line"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="d-flex">
                <p className="detail-content"> Notice No:</p>
                <p className="content-right">{bidDetail?.tender_number}</p>
              </div>
              <div className="d-flex">
                <p className="detail-content"> Entity Name:</p>
                <p className="content-right">{bidDetail?.public_entity_name}</p>
              </div>
              <div className="d-flex">
                <p className="detail-content"> Published Date: </p>
                <p className="content-right">
                  {bidDetail?.pubilshing_date.slice(0, 10)}
                </p>
              </div>

              <div className="d-flex">
                <p className="detail-content">Last Submission Date:</p>
                <p className="content-right">
                  {bidDetail?.submission_date?.toLocaleString().slice(0, 10)} |
                  12:00 PM
                </p>
              </div>
              {isNoticeCategoryEOI(bidDetail?.notice_category as string) &&
                bidDetail?.opening_date && (
                  <div className="d-flex">
                    <p className="detail-content">Final Submission Date:</p>
                    <p className="content-right">
                      {bidDetail?.opening_date?.toLocaleString().slice(0, 10)} |
                      12:00 PM
                    </p>
                  </div>
                )}
            </div>
            <div className="col-md-6">
              <div className="d-flex">
                <p className="detail-content">Project Title:</p>
                <p className="content-right">{bidDetail?.title} </p>
              </div>
              <div className="d-flex">
                <p className="detail-content">Procurement Type: </p>
                <p className="content-right">
                  {bidDetail?.procurement_type?.map(
                    (item: ITenderAttributes, index: number) => {
                      if (index !== bidDetail.procurement_type.length - 1) {
                        return item.label + ",";
                      }
                      return item.label;
                    }
                  )}
                </p>
              </div>
              {/* <div className="d-flex">
              <p className="detail-content">Bidding Open Date:</p>
              <p className="content-right">2022-09-09</p>
            </div> */}

              <div className="d-flex">
                <p className="detail-content">Project Type:</p>
                <p className="content-right">
                  {bidDetail?.project_category?.map(
                    (item: ITenderAttributes, index: number) => {
                      if (index !== bidDetail.project_category.length - 1) {
                        return item.label + ",";
                      }
                      return item.label;
                    }
                  )}
                </p>
              </div>
              <div className="d-flex">
                <p className="detail-content">Notice Category:</p>
                <p className="content-right">{bidDetail?.notice_category}</p>
              </div>
            </div>
          </div>
          <div className="bid-page-buttons">
            <button
              type="button"
              className="red-btn"
              onClick={() => {
                handleButtonClick();
              }}
            >
              <Icon className="doc-icon" path={mdiFileDocumentOutline} />
              Bid Document
            </button>

            <div className="bid-buutons">
              {(!isAuthenticate || isBidder(role)) &&
                Number(bidDetail?.remainingDays) > 0 && (
                  <div className="btn-combination mr-2">
                    <div className="mg-btn-right">
                      <button
                        className="transparent-btn"
                        onClick={() => {
                          handleOnClickBid(Number(id));
                        }}
                      >
                        <img
                          className="btn-img-icon-size"
                          src={require("../../images/bidblue.png")}
                          alt="images"
                        />
                        Bid
                      </button>
                    </div>
                  </div>
                )}
              {isBidder(role) && (
                <div className="btn-combination mr-2">
                  <div className="mg-btn-right">
                    <button
                      className="save-bid-btn"
                      onClick={() => {
                        saveBids(Number(id));
                      }}
                    >
                      <FontAwesomeIcon className="icon-bg" icon={faSave} />
                      Save Bid
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
          {bidDetail?.hide_bidder && (
            <Note>
              The publisher has chosen to keep the participant's details
              confidential.
            </Note>
          )}
        </div>
      </div>
    </>
  );
};
